import Serializer, { type DeserializeArguments } from './Serializer';
import { isHTMLElementNode } from '../helpers/serializerHelpers';

class SerializerGoogleDocs extends Serializer {
  static deserialize({
    el,
    markAttributes,
    next,
    context,
  }: DeserializeArguments) {
    if (!isHTMLElementNode(el)) return;

    // Skip <b id="docs-internal-guid... tag and only process its children.
    if (
      el.tagName.toLowerCase() === 'b' &&
      el.id.startsWith('docs-internal-guid')
    ) {
      return next(el.childNodes, markAttributes);
    }

    // When the contents of a google sheets cell is copy/pasted,
    // the html is a <span> with a data-sheets-value attribute.
    // we need this info to later preserve whitespace if rendering
    // text nodes inside the cell
    if (el.tagName.toLowerCase() === 'span' && el.dataset?.sheetsValue) {
      context.inGoogleSheetCell = true;
      const children = next(el.childNodes, markAttributes);
      context.inGoogleSheetCell = false;
      return children;
    }

    // No nothing for other tags.
  }

  static serialize(): React.ReactNode {
    return null;
  }
}

export default SerializerGoogleDocs;
